import { css } from 'linaria';

export const fadeIn = css`
    animation: fadeIn 1s cubic-bezier(0, 0, 0.2, 1) forwards;

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }
`;

export const slideUp = css`
    animation: slide-up 0.3s cubic-bezier(0.5, 0, 0.7, 1.5) forwards;

    @keyframes slide-up {
        from {
            opacity: 0;
            transform: translateY(24px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const scaleUp = css`
    animation: scale-up 0.3s cubic-bezier(0.5, 0, 0.7, 1.5) forwards;

    @keyframes scale-up {
        from {
            opacity: 0;
            transform: scale(0.75);
        }

        to {
            opacity: 1;
            transform: scale(1);
        }
    }
`;

export const Motion = {
    fadeIn,
    slideUp,
    scaleUp,
};
